export const SPECIAL_CATEGORIES_SLUGS_EN = [
  'promotions',
  'new',
  'sale',
  'popular',
  'liquidation',
];

